import { Component, OnInit } from '@angular/core';
import 'codemirror/mode/javascript/javascript';
import {Samples} from '../shared/classes/Samples';

@Component({
  selector: 'rm-javascript',
  template: `    
    <rm-snippet [title]="'tablesort.pipe.ts'" [content]="tableSortPipe"></rm-snippet>
    <rm-snippet [title]="'inputFilter.pipe.ts'" [content]="inputFilterPipe"></rm-snippet>
    <rm-snippet [title]="'breadcrumb.component.ts'" [content]="breadcrumbComponent"></rm-snippet>
    <rm-snippet [title]="'breadcrumb.service.ts'" [content]="breadcrumbService"></rm-snippet>
    <rm-snippet [title]="'error.component.ts'" [content]="errorComponent"></rm-snippet>
    <rm-snippet [title]="'piechart.component.ts'" [content]="piechartComponent"></rm-snippet>
    <rm-snippet [title]="'accordian-group.component.ts'" [content]="accordianGroupComponent"></rm-snippet>
    <rm-snippet [title]="'accordian.component.ts'" [content]="accordianComponent"></rm-snippet>
  `,
  styleUrls: ['./javascript.component.scss']
})
export class JavascriptComponent implements OnInit {
  title: string;
  tableSortPipe: string;
  inputFilterPipe: string;
  breadcrumbComponent: string;
  breadcrumbService: string;
  errorComponent: string;
  piechartComponent: string;
  accordianGroupComponent: string;
  accordianComponent: string;

  ngOnInit() {
    this.tableSortPipe = Samples.TABLE_SORT_PIPE;
    this.inputFilterPipe = Samples.INPUT_FILTER_PIPE;
    this.breadcrumbComponent = Samples.BREADCRUMB_COMPONENT_TS;
    this.breadcrumbService = Samples.BREADCRUMB_SERVICE;
    this.errorComponent = Samples.ERROR_COMPONENT;
    this.piechartComponent = Samples.PIECHART_COMPONENT;
    this.accordianGroupComponent = Samples.ACCORDIAN_GROUP_COMPONENT;
    this.accordianComponent = Samples.ACCORDIAN_COMPONENT;
  }
}



// WEBPACK FOOTER //
// ./src/app/javascript/javascript.component.ts